import Form, { Field, HelperMessage } from '@atlaskit/form';
import Textfield from '@atlaskit/textfield';
import styled from '@emotion/styled';
import React, { Fragment } from 'react';

export type SwitchAccountsEmailFormProps = {
  readonly email: string;
  readonly switchAccountLink: React.ReactNode;
};

export function SwitchAccountsEmailForm({
  email,
  switchAccountLink
}: SwitchAccountsEmailFormProps) {
  return (
    <Form>
      {({ formProps }: any) => (
        <form {...formProps}>
          <Field
            label="Work email"
            name="email"
            isRequired
            defaultValue={email}
          >
            {({ fieldProps }: any) => (
              <Fragment>
                <StyledTextField {...fieldProps} isDisabled />
                <HelperMessage>{switchAccountLink}</HelperMessage>
              </Fragment>
            )}
          </Field>
        </form>
      )}
    </Form>
  );
}

const StyledTextField = styled(Textfield)`
  // force box-sizing: content-box; to prevent styling issues in magnolia
  box-sizing: content-box;
`;
